import { mapGetters } from "vuex";
import { hasPermission, hasMultiplePermission } from "@/store/modules/auth";
import { ROLES, PERMISSIONS } from "@/utils/constant";

export const PermissionMixin = {
  data() {
    return {
      ROLES,
      PERMISSIONS,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isSupAdmin() {
      return this.userInfo.role === this.ROLES.SUPER_ADMIN;
    },
    isSalesPerson() {
      return this.userInfo.role === this.ROLES.SALES_PERSON;
    },
    isSalesManager() {
      return this.userInfo.role === this.ROLES.SALES_MANAGER;
    },
    isPickingSupervisor() {
      return this.userInfo.role === this.ROLES.PICKING_SUPERVISOR;
    },
    isPicker() {
      return this.userInfo.role === this.ROLES.PICKER;
    },
    isDispatchSupervisor() {
      return this.userInfo.role === this.ROLES.DISPATCH_SUPERVISOR;
    },
    isCarSupervisor() {
      return this.userInfo.role === this.ROLES.CAR_SUPERVISOR;
    },
    isDispatcher() {
      return this.userInfo.role === this.ROLES.DISPATCHER;
    },
    isAccounting() {
      return this.userInfo.role === this.ROLES.ACCOUNTING;
    },
    isInventoryPerson() {
      return this.userInfo.role === this.ROLES.INVENTORY_PERSON;
    },
    canSellItem() {
      return this.isSupAdmin || this.isSalesPerson || this.isSalesManager;
    },
    canViewAllInvoice() {
      const roleCanViewAll =
        this.isSupAdmin ||
        this.isPicker ||
        this.isDispatcher ||
        this.isPickingSupervisor ||
        this.isDispatchSupervisor ||
        this.isAccounting ||
        this.isSalesManager;
      // "SEE OTHER" grants the ability to view everyone's invoices/reports,
      // "CAN NOT SEE OTHER" revokes it even for roles that normally can (e.g. sales manager).
      return (
        (roleCanViewAll ||
          hasPermission(PERMISSIONS.SEE_OTHER_SALE_REPORT_AND_INVOICE)) &&
        !hasPermission(PERMISSIONS.CANNOT_SEE_OTHER_SALE_REPORT_AND_INVOICE)
      );
    },
  },
  methods: {
    hasPermission(permission) {
      return hasPermission(permission);
    },
    hasMultiplePermission(permissions) {
      return hasMultiplePermission(permissions);
    },
  },
};
